module.exports = __webpack_public_path__ + "static/media/serie10.ab0d0330.pdf";